import * as React from "react";
const SvgFiRrCloudHail = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cloud-hail_svg__a)">
      <path
        fill="#062147"
        d="M19 19.5a1 1 0 0 1-.385-1.923c4.967-2.007 4.218-9.47-1.032-10.473a3.01 3.01 0 0 1-2.158-1.672A6 6 0 0 0 4.086 6.967a6.1 6.1 0 0 0 .024 2.181 3 3 0 0 1-.964 2.762 3.524 3.524 0 0 0 .41 5.5 1 1 0 1 1-1.112 1.662A5.534 5.534 0 0 1 1.8 10.43a1 1 0 0 0 .345-.9 8.2 8.2 0 0 1-.033-2.889A7.95 7.95 0 0 1 8.5.137a8.06 8.06 0 0 1 8.735 4.44 1.04 1.04 0 0 0 .742.57c7.187 1.423 8.193 11.483 1.411 14.277A1 1 0 0 1 19 19.5M7 15a1 1 0 1 0 2 0 1 1 0 0 0-2 0m4 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0m4 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0m-9 4a1 1 0 1 0 2 0 1 1 0 0 0-2 0m4 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0m4 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0m-9 4a1 1 0 1 0 2 0 1 1 0 0 0-2 0m4 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0m4 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cloud-hail_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCloudHail;
